import React from "react";

type PropsType = {
  color?: string;
  style?: React.CSSProperties;
  size?: number;
};

const CircleCheckSolid = ({
  size = 24,
  style = {},
  color = "currentColor",
}: PropsType) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clip-path="url(#clip0_43_16041)">
        <path
          d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM18.707 7.29297C18.3165 6.90244 17.6835 6.90244 17.293 7.29297L10 14.5859L7.20703 11.793L7.13086 11.7246C6.73809 11.4043 6.15908 11.4269 5.79297 11.793C5.42685 12.1591 5.40426 12.7381 5.72461 13.1309L5.79297 13.207L8.93945 16.3535C9.52523 16.9393 10.4748 16.9393 11.0605 16.3535L18.707 8.70703C19.0976 8.31651 19.0976 7.68349 18.707 7.29297Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_43_16041">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CircleCheckSolid;
